export class NativeStreamTransformFunction {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "connection",
            "baseName": "connection",
            "type": "string",
            "format": ""
        },
        {
            "name": "params",
            "baseName": "params",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "model",
            "baseName": "model",
            "type": "string",
            "format": ""
        },
        {
            "name": "systemPrompt",
            "baseName": "systemPrompt",
            "type": "string",
            "format": ""
        },
        {
            "name": "prompt",
            "baseName": "prompt",
            "type": "string",
            "format": ""
        },
        {
            "name": "temperature",
            "baseName": "temperature",
            "type": "number",
            "format": "double"
        },
        {
            "name": "maxOutputTokens",
            "baseName": "maxOutputTokens",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "outputSchema",
            "baseName": "outputSchema",
            "type": "NativeStreamStructOutputType",
            "format": ""
        },
        {
            "name": "body",
            "baseName": "body",
            "type": "string",
            "format": ""
        },
        {
            "name": "responsePointer",
            "baseName": "responsePointer",
            "type": "string",
            "format": ""
        },
        {
            "name": "state",
            "baseName": "state",
            "type": "string",
            "format": ""
        },
        {
            "name": "questions",
            "baseName": "questions",
            "type": "Array<NativeStreamTransformQuestion>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamTransformFunction.attributeTypeMap;
    }
    constructor() {
    }
}
